var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import has from 'lodash/has';
import { addRulesValidationErrorInfo, capitalize, isEmptyArray } from '../utils/utils';
import request from './request';
import countries from 'i18n-iso-countries';
import { CONSTANTS } from '../utils/constants';
import { getToken } from './token';
import { getUserPermission } from './userPermission';
var productionUrl = 'https://productprice.financialflows.cimpress.io';
var stgUrl = 'https://productprice.financialflows.cimpress.io';
var pricingTermUrl = 'https://pricingterm.financialflows.cimpress.io';
export function getContracts(sku, isProduction) {
  var mode = 'cors';
  var headers = new Headers({
    Authorization: "Bearer " + getToken()
  });
  var credentials = 'same-origin';
  var options = {
    method: 'GET',
    mode: mode,
    headers: headers,
    credentials: credentials
  };
  var productPriceUrl = isProduction ? productionUrl : stgUrl;
  return fetch(productPriceUrl + "/api/v2/priceStatus/" + sku, options).then(function (res) {
    if (res.ok) {
      return res.json();
    }

    throw res;
  }).then(function (res) {
    var relationships = res.relationships;
    var contracts = [];
    var catalogPriceModels = [];

    if (relationships && relationships.length) {
      for (var i = 0; i < relationships.length; i += 1) {
        var relationship = relationships[i];

        if (relationship.buyer.buyerId === '*') {
          var priceModelId = relationship.priceModelId,
              priceModelRevisionId = relationship.priceModelRevisionId,
              seller = relationship.seller,
              buyerType = relationship.buyer.buyerType;
          catalogPriceModels.push({
            priceModelId: priceModelId,
            revisionId: priceModelRevisionId,
            seller: seller,
            buyer: {
              buyerId: CONSTANTS.CATALOG_PRICE,
              buyerType: buyerType
            }
          });
        } else {
          var buyer = relationship.buyer,
              seller = relationship.seller,
              priceModelId = relationship.priceModelId,
              revisionId = relationship.priceModelRevisionId;
          contracts.push({
            buyer: buyer,
            seller: seller,
            priceModelId: priceModelId,
            revisionId: revisionId
          });
        }
      } // Sorting contracts


      contracts.sort(function (a, b) {
        if (a.buyer.buyerId < b.buyer.buyerId) {
          return -1;
        }

        return 1;
      });
      return {
        sku: sku,
        contracts: contracts,
        catalogPriceModels: catalogPriceModels
      };
    }

    return {
      sku: sku
    };
  });
}
export var getSellersForSku = function getSellersForSku(mcpSku, skuSellerId, isProduction, productPriceContractsInfo) {
  return __awaiter(void 0, void 0, void 0, function () {
    var productPriceUrl, sellers, merchants, contracts, catalogPriceModels, manufacturingCostModels, sellersInfoPromise, contractsInfoPromise, productInfo, externalFulfillerId, manufacturingCostPromises, allSellerIds, sellerMapInfo, sellersMap, hasPermissionForFulfiller;

    var _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          productPriceUrl = isProduction ? productionUrl : stgUrl;
          sellers = {};
          merchants = {};
          contracts = [];
          catalogPriceModels = [];
          manufacturingCostModels = [];
          if (!productPriceContractsInfo) return [3
          /*break*/
          , 1];
          contracts = productPriceContractsInfo.contracts;
          contracts.forEach(function (contract) {
            var seller = contract.seller,
                buyer = contract.buyer;
            sellers[seller.sellerId] = seller;
            merchants[buyer.buyerId] = buyer;
          });
          return [3
          /*break*/
          , 3];

        case 1:
          sellersInfoPromise = request(productPriceUrl + "/api/v2/priceStatus/" + mcpSku, 'GET', null, true).then(function (res) {
            if (!res.errorResponse) {
              return res;
            }

            throw res;
          });
          contractsInfoPromise = request(pricingTermUrl + "/api/v0/activeterms:searchbysku?sku=" + mcpSku).then(function (res) {
            if (!res.errorResponse) {
              return res;
            }

            throw res;
          });
          return [4
          /*yield*/
          , Promise.all([sellersInfoPromise, contractsInfoPromise]).then(function (response) {
            return __awaiter(void 0, void 0, void 0, function () {
              var _a, sellersInfo, contractsInfo, activeContractsInfo;

              return __generator(this, function (_b) {
                _a = __read(response, 2), sellersInfo = _a[0], contractsInfo = _a[1];
                activeContractsInfo = contractsInfo.activeTerms || null;

                if (activeContractsInfo) {
                  activeContractsInfo = activeContractsInfo.filter(function (_a) {
                    var isEffective = _a.isEffective;
                    return isEffective;
                  });
                }

                if (Array.isArray(sellersInfo.relationships) && sellersInfo.relationships.length) {
                  sellersInfo.relationships.forEach(function (relationship) {
                    var seller = relationship.seller,
                        buyer = relationship.buyer,
                        priceModelId = relationship.priceModelId,
                        priceModelRevisionId = relationship.priceModelRevisionId;
                    var sellerId = seller.sellerId;
                    var buyerId = buyer.buyerId,
                        buyerType = buyer.buyerType;

                    if (buyerId === '*') {
                      catalogPriceModels.push({
                        priceModelId: priceModelId,
                        revisionId: priceModelRevisionId,
                        seller: seller,
                        buyer: {
                          buyerId: CONSTANTS.CATALOG_PRICE,
                          buyerType: buyerType
                        }
                      });
                    } else {
                      var contract = {
                        buyer: buyer,
                        seller: seller,
                        priceModelId: priceModelId,
                        revisionId: priceModelRevisionId
                      };

                      if (activeContractsInfo) {
                        var activeContract = activeContractsInfo.find(function (_a) {
                          var activeTerm = _a.activeTerm;
                          return buyer.buyerId === activeTerm.buyer.id && seller.sellerId === activeTerm.seller.id;
                        });

                        if (activeContract) {
                          var _a = activeContract.activeTerm,
                              contractId = _a.termId,
                              effectiveStartDate = _a.effectiveStartDate,
                              contractRevisionId = _a.revisionId,
                              accountId = _a.buyer.accountId;
                          contract = __assign(__assign({}, contract), {
                            contractId: contractId,
                            effectiveStartDate: effectiveStartDate,
                            contractRevisionId: contractRevisionId
                          });
                          buyer.accountId = accountId;
                        }
                      }

                      if (!merchants[buyer.buyerId]) {
                        merchants[buyer.buyerId] = buyer;
                      }

                      contracts.push(contract);
                    }

                    if (!sellers[sellerId]) {
                      sellers[sellerId] = seller;
                    }
                  });
                }

                return [2
                /*return*/
                ];
              });
            });
          })];

        case 2:
          _b.sent();

          _b.label = 3;

        case 3:
          if (!!Object.keys(sellers).length) return [3
          /*break*/
          , 5];
          return [4
          /*yield*/
          , request("https://introduction.products.cimpress.io/v3/mcpSkus/" + mcpSku).then(function (response) {
            return response;
          }).catch(function (err) {
            return null;
          })];

        case 4:
          productInfo = _b.sent();
          externalFulfillerId = productInfo && productInfo.externalFulfillerId;

          if (externalFulfillerId) {
            sellers[externalFulfillerId] = {
              sellerId: externalFulfillerId,
              sellerType: 'fulfillers'
            };
          }

          _b.label = 5;

        case 5:
          if (!sellers || !sellers[skuSellerId]) {
            sellers[skuSellerId] = {
              sellerId: skuSellerId,
              sellerType: 'fulfillers'
            };
          }

          manufacturingCostPromises = [];
          Object.keys(sellers).forEach(function (sellerId) {
            var manufacturingCostRequestBody = {
              Skus: [mcpSku],
              seller: sellers[sellerId]
            };
            manufacturingCostPromises.push(request(productPriceUrl + "/api/v1/manufacturingCost", 'POST', JSON.stringify(manufacturingCostRequestBody)).then(function (manufacturingModels) {
              if (manufacturingModels && manufacturingModels.manufacturingCosts && manufacturingModels.manufacturingCosts.length > 0) {
                manufacturingModels.manufacturingCosts.forEach(function (cost) {
                  manufacturingCostModels.push({
                    priceModelId: cost.priceModelId,
                    revisionId: cost.revisionId,
                    seller: cost.seller,
                    buyer: {
                      buyerId: CONSTANTS.MANUFACTURING_COST,
                      buyerType: 'merchants'
                    }
                  });
                });
              }
            }));
          });
          return [4
          /*yield*/
          , Promise.all(manufacturingCostPromises)];

        case 6:
          _b.sent();

          allSellerIds = Object.keys(sellers);
          sellerMapInfo = allSellerIds.map(function (sellerId) {
            var sellerDetails = sellers[sellerId];
            return request('https://startingpriceapi.financialflows.cimpress.io/v1/sellerInfo', 'POST', JSON.stringify({
              seller: sellerDetails
            }));
          });
          return [4
          /*yield*/
          , Promise.all(sellerMapInfo)];

        case 7:
          sellerMapInfo = _b.sent();
          sellersMap = {};
          sellerMapInfo.forEach(function (sellerInfo) {
            sellersMap[sellerInfo.sellerId] = __assign({}, sellerInfo);
          });
          return [4
          /*yield*/
          , getUserPermission(skuSellerId)];

        case 8:
          hasPermissionForFulfiller = _b.sent();
          return [2
          /*return*/
          , (_a = {}, _a[mcpSku] = {
            sellers: sellersMap,
            merchants: merchants,
            catalogPriceModels: catalogPriceModels,
            contracts: contracts,
            manufacturingCostModels: manufacturingCostModels,
            hasPermissionForFulfiller: hasPermissionForFulfiller
          }, _a)];
      }
    });
  });
};

var parseResponse = function parseResponse(response) {
  return __awaiter(void 0, void 0, void 0, function () {
    var status, statusText, _a, innerDetails, Message, issues, message;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (response.ok) {
            return [2
            /*return*/
            , response.json()];
          }

          status = response.status, statusText = response.statusText;
          return [4
          /*yield*/
          , response.json()];

        case 1:
          _a = _b.sent(), innerDetails = _a.innerDetails, Message = _a.Message, issues = _a.ModelState["request.EvaluationParameters"];
          message = 'An Error Occurred';

          if (innerDetails && innerDetails.message) {
            message = JSON.parse(innerDetails).message;
          } else if (Message) {
            message = Message;
          }

          if (issues) {
            message = message + "\n" + issues.join('\n');
          }

          return [2
          /*return*/
          , {
            status: status,
            statusText: statusText,
            message: message
          }];
      }
    });
  });
}; // const logPriceErrors = async (priceResults: any, mcpSku: string, onGetAccessToken: () => string): Promise<any> => {
//   const logger = new Logger(onGetAccessToken);
//   const logging: any = {};
//   const noOfPrices = priceResults.length;
//
//   for (let index = 0; index < noOfPrices; index++) {
//     if (priceResults[index] && 'evaluationGroups' in priceResults[index]) {
//       const evaluationGroupLength = priceResults[index].evaluationGroups.length;
//       for (let j = 0; j < evaluationGroupLength; j++) {
//         if ('error' in priceResults[index].evaluationGroups[j]) {
//           if (priceResults[index].evaluationGroups[j].error.message) {
//             if (!logging[priceResults[index].evaluationGroups[j].error.message]) {
//               logging[priceResults[index].evaluationGroups[j].error.message] = {
//                 errorCode: priceResults[index].evaluationGroups[j].error.code,
//                 contracts: [priceResults[index].buyer.buyerId],
//                 mcpSku,
//               };
//             } else logging[priceResults[index].evaluationGroups[j].error.message].contracts.push(priceResults[index].buyer.buyerId);
//           }
//           break;
//         }
//       }
//     }
//   }
//   if (Object.keys(logging).length !== 0) {
//     const loggerData: any[] = [];
//     Object.keys(logging).forEach(key => {
//       loggerData.push({
//         errorCode: logging[key].errorCode,
//         errorMessage: key,
//         contracts: logging[key].contracts,
//         mcpSku: logging[key].mcpSku,
//       });
//     });
//     logger.logError(loggerData, 'productPrice');
//   }
// };


export var getContractPrices = function getContractPrices(isProduction, mcpSku, seller, buyers, evaluationParameters) {
  return __awaiter(void 0, void 0, void 0, function () {
    var outputFilter, body, headers, mode, credentials, options, productPriceUrl, response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (isEmptyArray(buyers)) {
            return [2
            /*return*/
            , [null]];
          }

          outputFilter = ['price'];
          body = JSON.stringify({
            mcpSku: mcpSku,
            seller: seller,
            buyers: buyers,
            evaluationParameters: evaluationParameters,
            outputFilter: outputFilter
          });
          headers = new Headers({
            Authorization: "Bearer " + getToken(),
            'Content-Type': 'application/json'
          });
          mode = 'cors';
          credentials = 'same-origin';
          options = {
            method: 'POST',
            mode: mode,
            body: body,
            headers: headers,
            credentials: credentials
          };
          productPriceUrl = isProduction ? productionUrl : stgUrl;
          return [4
          /*yield*/
          , fetch(productPriceUrl + "/api/v1/bulkevaluate", options)];

        case 1:
          response = _a.sent();
          return [2
          /*return*/
          , parseResponse(response).then(function (parsedResponse) {
            if (!Array.isArray(parsedResponse)) {
              var results_1 = [];
              buyers.forEach(function (buyer) {
                results_1.push(__assign({
                  mcpSku: mcpSku,
                  seller: seller,
                  buyer: buyer
                }, parsedResponse));
              });
              return results_1;
            }

            return parsedResponse;
          })];
      }
    });
  });
};
export var getPriceForPriceModel = function getPriceForPriceModel(isProduction, mcpSku, catalogPriceModel, evaluationParameters) {
  return __awaiter(void 0, void 0, void 0, function () {
    var outputFilter, priceModelId, revisionId, seller, buyer, body, headers, mode, credentials, options, productPriceUrl, title;
    return __generator(this, function (_a) {
      if (!catalogPriceModel) {
        return [2
        /*return*/
        , [{
          statusText: 'Error',
          message: CONSTANTS.CATALOG_PRICE_MISSING_MESSAGE
        }]];
      }

      outputFilter = ['price'];
      priceModelId = catalogPriceModel.priceModelId, revisionId = catalogPriceModel.revisionId, seller = catalogPriceModel.seller, buyer = catalogPriceModel.buyer;
      body = JSON.stringify({
        priceModelId: priceModelId,
        revisionId: revisionId,
        evaluationParameters: evaluationParameters,
        outputFilter: outputFilter
      });
      headers = new Headers({
        Authorization: "Bearer " + getToken(),
        'Content-Type': 'application/json'
      });
      mode = 'cors';
      credentials = 'same-origin';
      options = {
        method: 'POST',
        mode: mode,
        body: body,
        headers: headers,
        credentials: credentials
      };
      productPriceUrl = isProduction ? productionUrl : stgUrl;
      title = catalogPriceModel.title;

      if (revisionId) {
        return [2
        /*return*/
        , fetch(productPriceUrl + "/api/v1/bulkevaluate/publishedPriceModel", options).then(function (response) {
          return parseResponse(response);
        }).then(function (result) {
          return [__assign(__assign({}, result), {
            mcpSku: mcpSku,
            seller: seller,
            buyer: buyer,
            title: title
          })];
        }).catch(function () {
          return [{
            statusText: 'Error',
            message: 'Unable to fetch Price',
            title: title
          }];
        })];
      }

      return [2
      /*return*/
      , fetch(productPriceUrl + "/api/v1/bulkevaluate/unpublishedPriceModel", options).then(function (response) {
        return parseResponse(response);
      }).then(function (result) {
        return [__assign(__assign({}, result), {
          mcpSku: mcpSku,
          seller: seller,
          buyer: buyer,
          title: title
        })];
      }).catch(function () {
        return [{
          statusText: 'Error',
          message: 'Unable to fetch Price',
          title: title
        }];
      })];
    });
  });
};

var getEmptyCatalogPriceResult = function getEmptyCatalogPriceResult(mcpSku, catalogPriceResult) {
  var newCatalogPriceResult = catalogPriceResult;

  if (!catalogPriceResult || typeof catalogPriceResult !== 'object') {
    newCatalogPriceResult = {};
  }

  newCatalogPriceResult.mcpSku = mcpSku;
  newCatalogPriceResult.buyer = {
    buyerType: 'merchants',
    buyerId: CONSTANTS.CATALOG_PRICE
  };
  return newCatalogPriceResult;
};

export function bulkEval(isProduction, mcpSku, evaluationParameters, fulfillerId, contracts, catalogPriceModels, manufacturingCostModels, productPriceContractsInfo) {
  return __awaiter(this, void 0, void 0, function () {
    var promises, catalogPriceResult, contractMap_1;
    return __generator(this, function (_a) {
      promises = [];

      if (productPriceContractsInfo && productPriceContractsInfo.contracts) {
        productPriceContractsInfo.contracts.forEach(function (contract) {
          promises.push(getPriceForPriceModel(isProduction, mcpSku, contract, evaluationParameters));
        });
      } else {
        if (isEmptyArray(contracts) && (!catalogPriceModels || !Array.isArray(catalogPriceModels) || !catalogPriceModels.length) && (!manufacturingCostModels || !Array.isArray(manufacturingCostModels) || !manufacturingCostModels.length)) {
          catalogPriceResult = getEmptyCatalogPriceResult(mcpSku);
          catalogPriceResult.statusText = 'Error';
          catalogPriceResult.message = CONSTANTS.NO_PRICE_MESSAGE;
          return [2
          /*return*/
          , [catalogPriceResult]];
        }

        contractMap_1 = {};
        contracts.forEach(function (contract) {
          var seller = contract.seller,
              buyer = contract.buyer;
          var sellerId = seller.sellerId;

          if (!contractMap_1[sellerId]) {
            contractMap_1[sellerId] = {
              seller: seller,
              buyers: []
            };
          }

          contractMap_1[sellerId].buyers.push(buyer);
        });
        Object.values(contractMap_1).forEach(function (value) {
          var seller = value.seller,
              buyers = value.buyers;
          promises.push(getContractPrices(isProduction, mcpSku, seller, buyers, evaluationParameters));
        });
        catalogPriceModels.forEach(function (catalogPriceModel) {
          promises.push(getPriceForPriceModel(isProduction, mcpSku, catalogPriceModel, evaluationParameters));
        });
        manufacturingCostModels.forEach(function (manufacturingCostModel) {
          promises.push(getPriceForPriceModel(isProduction, mcpSku, manufacturingCostModel, evaluationParameters));
        });
      }

      return [2
      /*return*/
      , Promise.all(promises).then(function (results) {
        var normalizedResults = [];
        results.forEach(function (result) {
          result.forEach(function (item) {
            normalizedResults.push(item);
          });
        });
        return normalizedResults;
      })];
    });
  });
}
export var getCountryName = function getCountryName(attributeValue) {
  return countries.getName(attributeValue, 'en') + " (" + attributeValue + ")";
};
export var getCompetitorsPrices = function getCompetitorsPrices(combinations, modelMappingIds) {
  var body = {
    combinations: combinations,
    modelMappingIds: modelMappingIds
  };
  return request(' https://competitortracking.ff.cimpress.io/api/v1/competitorprice', 'PUT', JSON.stringify(body));
};
export var modifyBulkEvalResults = function modifyBulkEvalResults(results, pivots, priceMode, headers, sku, skuData, contracts, catalogPriceModels, manufacturingCostModels, sellers, productPriceContractsInfo) {
  var resolvedAttributes = skuData[sku].resolvedAttributes;
  var rowData = {};
  var sellerMap = sellers[sku];
  results.forEach(function (result) {
    if (result && result.evaluationGroups) {
      var buyer_1 = result.buyer,
          sellerId_1 = result.seller.sellerId,
          evaluationGroups = result.evaluationGroups,
          title_1 = result.title;
      var matchingContract = productPriceContractsInfo && productPriceContractsInfo.contracts && productPriceContractsInfo.contracts.find(function (contract) {
        return contract.title === title_1;
      });
      var multiplier_1 = 1;

      if (matchingContract && matchingContract.modifiers) {
        var _a = matchingContract.modifiers,
            discountPercent = _a.discountPercent,
            markupPercent = _a.markupPercent;

        if (discountPercent) {
          multiplier_1 -= discountPercent / 100;
        }

        if (markupPercent) {
          multiplier_1 += markupPercent / 100;
        }
      }

      evaluationGroups.forEach(function (group) {
        var _a, _b;

        var inputs = group.inputs,
            price = group.price,
            error = group.error;

        if (multiplier_1 !== 1 && price && price.amount) {
          price.amount *= multiplier_1;
        }

        var matchLength = 0;
        var quantity = null;
        var matches = {};

        if (price || error) {
          for (var i = 0; i < inputs.length; i += 1) {
            for (var j = 0; j < pivots.length; j += 1) {
              var pivot = pivots[j];

              if (!matches[capitalize(pivot.key)] && inputs[i] && inputs[i].attributeKey.toLowerCase() === pivot.key.toLowerCase()) {
                matches[capitalize(pivot.key)] = pivot.key.toLowerCase() === 'country' ? getCountryName(inputs[i].attributeValue) : inputs[i].attributeValue;
                matchLength += 1;
              }

              if (inputs[i].attributeKey.toLowerCase() === 'quantity' && inputs[i].class.toLowerCase() === 'order') {
                quantity = inputs[i].attributeValue;
              }
            }

            if (matchLength === pivots.length && quantity !== null) {
              break;
            }
          }

          var properCaseKeyA = capitalize(pivots[0].key);
          var properCaseKeyB_1 = pivots[1] && capitalize(pivots[1].key);
          var X = matches[properCaseKeyA];

          if (X) {
            var rowKey_1 = properCaseKeyA + "|" + matches[properCaseKeyA];
            var rowElement = [];

            if (rowData[rowKey_1]) {
              rowElement = rowData[rowKey_1];
            }

            var resolvedAttribute = resolvedAttributes.find(function (item) {
              return item.key.toLowerCase() === rowKey_1.toLowerCase();
            });
            var buyerId = buyer_1.buyerId;
            var sellerName = sellerMap[sellerId_1].sellerName;
            var header = sku + "|" + CONSTANTS.CONTRACTS + "|" + sellerName + "-" + buyerId + "|";

            if (productPriceContractsInfo) {
              header = result.title;
            } else if (buyerId === CONSTANTS.CATALOG_PRICE || buyerId === CONSTANTS.MANUFACTURING_COST) {
              header = sku + "|" + buyerId + "|" + sellerName + "|";
            }

            var found = resolvedAttribute && resolvedAttribute.values[0];
            var columnKey = productPriceContractsInfo ? header : header + "|";

            if (pivots[1] && matches[properCaseKeyB_1]) {
              columnKey = "" + header + matches[properCaseKeyB_1] + "|";
              found = resolvedAttribute && resolvedAttribute.values.find(function (item) {
                return item.key.toLowerCase() === (properCaseKeyB_1 + "|" + matches[properCaseKeyB_1]).toLowerCase();
              });
            }

            if (found) {
              if (price) {
                var totalPrice = price.totalAmount ? price.totalAmount : price.amount;
                var displayPrice = priceMode === 'total' ? totalPrice : totalPrice / quantity;
                rowElement.push((_a = {}, _a[columnKey] = {
                  attributes: found.attributes,
                  productPrice: {
                    totalPrice: totalPrice,
                    displayPrice: displayPrice,
                    currency: price.currency
                  },
                  quantity: quantity
                }, _a));
              }

              if (error) {
                rowElement.push((_b = {}, _b[columnKey] = {
                  attributes: found.attributes,
                  errorMessage: error.code + " : " + error.message
                }, _b));
              }
            }

            rowData[rowKey_1] = rowElement;
          }
        }
      });
    } else if (has(result, 'buyer.buyerId') && has(result, 'seller.sellerId') && headers) {
      var mcpSku = result.mcpSku,
          buyerId_1 = result.buyer.buyerId,
          sellerId = result.seller.sellerId,
          statusText = result.statusText,
          message = result.message;
      var headerName_1 = buyerId_1;
      var sellerName_1 = sellerMap[sellerId].sellerName;

      if (buyerId_1 !== CONSTANTS.CATALOG_PRICE) {
        headerName_1 = sellerName_1 + "-" + buyerId_1;
      }

      var header = void 0;

      if (headers.headerList) {
        if (headers.headerList.length) {
          if (buyerId_1) {
            if (buyerId_1 === CONSTANTS.CATALOG_PRICE || buyerId_1 === CONSTANTS.MANUFACTURING_COST) {
              header = headers.headerList.find(function (item) {
                return item.name === buyerId_1;
              });

              if (header && header.children) {
                header = header.children.find(function (item) {
                  return item.name === sellerName_1;
                });
              }
            } else {
              header = headers.headerList.find(function (item) {
                return item.name === CONSTANTS.CONTRACTS;
              });

              if (header && header.children) {
                header = header.children.find(function (item) {
                  return item.name === headerName_1;
                });
              }
            }
          }
        } else if (headers.headerList[mcpSku]) {
          header = headers.headerList[mcpSku].find(function (item) {
            return item.name === headerName_1;
          });
        }
      } else {
        header = headers[headerName_1];
      }

      if (header) {
        header.errorType = 'error';

        if (statusText) {
          header.errorMessage = statusText;
        }

        if (message) {
          header.errorMessage = header.errorMessage ? header.errorMessage + ".\n " + message : message;
        }

        header.errorMessage = header.errorMessage || 'An Error Occurred';
      }
    }
  });
  addRulesValidationErrorInfo(rowData, skuData, sku, pivots, contracts, catalogPriceModels, sellers);
  return rowData;
};